module.exports = __webpack_public_path__ + "img/32.1a97a5bf.jpg";